const SOUND_FILES = {
  soft: '/sounds/alerts/soft.wav',
  chime: '/sounds/alerts/chime.wav',
  alarm: '/sounds/alerts/alarm.wav',
  bell: '/sounds/alerts/bell.wav',
  ping: '/sounds/alerts/ping.wav',
  pulse: '/sounds/alerts/pulse.wav',
  drop: '/sounds/alerts/drop.wav',
  thump: '/sounds/alerts/thump.wav',
  glass: '/sounds/alerts/glass.wav',
  digital: '/sounds/alerts/digital.wav',
  siren: '/sounds/alerts/siren.wav',
  buzz: '/sounds/alerts/buzz.wav',
  pop: '/sounds/alerts/pop.wav',
  chirp: '/sounds/alerts/chirp.wav'
};

const SOUND_PRESETS = {
  soft: { type: 'sine', frequency: 760, gain: 0.06, duration: 0.16 },
  chime: { type: 'triangle', frequency: 920, gain: 0.1, duration: 0.2 },
  alarm: { type: 'square', frequency: 1040, gain: 0.15, duration: 0.3 }
};

const DEFAULT_SOUND_MAP = {
  LOW: 'soft',
  HIGH: 'chime',
  CRITICAL: 'alarm'
};

const getSoundPresetForSeverity = (severity) => {
  try {
    const raw = localStorage.getItem('alert_sound_settings');
    if (raw) {
      const parsed = JSON.parse(raw);
      const key = (severity || 'LOW').toUpperCase();
      if (parsed && parsed[key]) {
        return parsed[key];
      }
    }
  } catch {
    // ignore localStorage errors
  }
  return DEFAULT_SOUND_MAP[(severity || 'LOW').toUpperCase()] || 'soft';
};

export const playNotificationSound = (severity = 'LOW') => {
  try {
    const soundKey = getSoundPresetForSeverity(severity);
    const filePath = SOUND_FILES[soundKey];
    const repeats = (severity || 'LOW').toUpperCase() === 'CRITICAL'
      ? 5
      : (severity || 'LOW').toUpperCase() === 'HIGH'
        ? 4
        : 3;
    const gapMs = 220;
    if (filePath) {
      const playOnce = (index = 0) => {
        const audio = new Audio(filePath);
        audio.volume = 0.6;
        audio.play().catch(() => {
          // fallback to synth if autoplay blocked
        });
        if (index + 1 < repeats) {
          setTimeout(() => playOnce(index + 1), gapMs);
        }
      };
      playOnce();
      return;
    }

    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;
    const preset = SOUND_PRESETS.soft;
    const ctx = new AudioCtx();
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();
    oscillator.type = preset.type;
    oscillator.frequency.value = preset.frequency;
    gain.gain.value = preset.gain;
    oscillator.connect(gain);
    gain.connect(ctx.destination);
    const playSynth = (index = 0) => {
      oscillator.start(ctx.currentTime + index * (preset.duration + gapMs / 1000));
      oscillator.stop(ctx.currentTime + index * (preset.duration + gapMs / 1000) + preset.duration);
    };
    for (let i = 0; i < repeats; i += 1) {
      playSynth(i);
    }
    setTimeout(() => {
      ctx.close();
    }, (preset.duration * repeats) * 1000 + gapMs * repeats);
  } catch (error) {
    // Ignore audio errors (autoplay restrictions, etc.)
  }
};

export const sendTradeNotification = (title, body) => {
  if (!('Notification' in window)) return;
  if (Notification.permission === 'granted') {
    new Notification(title, { body });
    return;
  }
  if (Notification.permission === 'default') {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        new Notification(title, { body });
      }
    });
  }
};

export const notifyTradeExecution = (title, body, severity = 'LOW') => {
  playNotificationSound(severity);
  sendTradeNotification(title, body);
};
